module.exports = __webpack_public_path__ + "img/OrizonMobile.6610c284.png";